import { CommonModule } from "@angular/common";
import { NgModule, Type } from "@angular/core";
import { LayoutDirectivesModule } from "@directives/_layout/_layout.directives.module";
import { MiscDirectivesModule } from "@directives/_misc/_misc.directives.module";
import { ResourceFiltersDirectivesModule } from "@directives/_resourceFilters/_resourceFilters.directives.module";
import { VehicleDirectivesModule } from "@directives/_vehicle/_vehicle.directives.module";
import { VeriDirectivesModule } from "@directives/_veri/_veri.directives.module";
import { PipesModule } from "src/app/_pipes/_pipes.module";
import { VehiclesPageRouteComponent } from "./_routes/vehicles/vehicles.component";

const privateComponents: Type<any>[] = [

];

const publicComponents: any[] = [
    VehiclesPageRouteComponent
];

const declarations: Type<any>[] = [
];

const providers: any[] = [
];

@NgModule({
    imports: [
        CommonModule,
        VeriDirectivesModule,
        LayoutDirectivesModule,
        PipesModule,
        ResourceFiltersDirectivesModule,
        MiscDirectivesModule,
        VehicleDirectivesModule
    ],
    providers: providers,
    entryComponents: [...publicComponents, ...privateComponents],
    declarations: [...publicComponents, ...privateComponents, ...declarations],
    exports: [...publicComponents, ...declarations]
})
export class FleetModule {
    constructor() {
    }
}
